<template>
  <div>
    <el-upload
      :limit="limit"
      :file-list="fileList"
      list-type="picture-card"
      :accept="accept"
      action="customize"
      :multiple="multiple"
      :before-upload="handleChange"
      :http-request="httpRequest"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      :on-preview="handlePictureCardPreview"
    >
      <el-input style="display: none;" v-model="filePath"></el-input>
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisibleT" custom-class="previewImg">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 9
    },
    fileMaxSize: {
      type: Number,
      default: 2
    },
    accept: {
      type: String,
      default: '.jpg,.jpeg,.png'
    },
    fileList: {
      type: Array,
      default: () => []
    },
    httpRequest: {
      type: Function,
      required: true
    },
    handleRemove: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisibleT: false,
      filePath: this.value
    };
  },
  watch: {
    value(newVal) {
      this.filePath = newVal;
    }
  },
  methods: {
    // 文件超出限制
    handleExceed() {
      this.$message.warning(`只能上传${this.limit}张图片，请重新选择！`);
    },
    // 更新文件路径
    updateFileList(fileList) {
      this.$emit('update:value', fileList[0] ? fileList[0].url : '');
    },
    handleChange(file) {
      const isLt5M = file.size / 1024 / 1024 < this.fileMaxSize;
      if (!isLt5M) {
        this.$message({
          showClose: true,
          message: `文件大小不能超过 ${this.fileMaxSize}MB`,
          type: "warning",
        });
        return false;
      }
    },
    handlePictureCardPreview(file){
      this.dialogImageUrl = file.url;
      this.dialogVisibleT = true
    }
  }
};
</script>

<style scoped>
/* Your styles for the upload component */
</style>
